import React from "react";
import "./AdDetailsDescription.css";

const AdDetailsDescription = ({ description }) => {

    return (
        <div className="item_description">
            <h5 className="description_title">⁍ Opis</h5>
            <div className="description">
                <p>{description}</p>
            </div>
        </div>
    )
}

export default AdDetailsDescription;